var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_851",
    "data-name": "Group 851",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.776,
    height: 22.163,
    viewBox: "0 0 20.776 22.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_851-2",
    "data-name": "Group 851",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M195.638,230.554a1.776,1.776,0,0,1-.7,1.5,5.639,5.639,0,0,1-1.745.979,16.513,16.513,0,0,1-5.637.881c-.4-.023-1.012-.043-1.623-.1a13.383,13.383,0,0,1-3.72-.827,5.527,5.527,0,0,1-1.631-.934,1.782,1.782,0,0,1-.7-1.5c.026-.5.024-1,0-1.5a1.746,1.746,0,0,1,.66-1.44,5.561,5.561,0,0,1,1.8-1.021,13.935,13.935,0,0,1,3.95-.8,17.283,17.283,0,0,1,6.291.605,6.294,6.294,0,0,1,2.365,1.2,1.758,1.758,0,0,1,.678,1.481A14.018,14.018,0,0,0,195.638,230.554Z",
    transform: "translate(-179.886 -225.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M248.42,341.591a6.172,6.172,0,0,1-2.338-1.2,1.752,1.752,0,0,1-.666-1.462c.025-.5,0-1,.006-1.5,0-.069.008-.137.014-.22.3.173.562.347.844.491a14.625,14.625,0,0,0,5.809,1.393,1.845,1.845,0,0,0-.1.605,2.021,2.021,0,0,0,.749,1.532l1.149,1.022A16.63,16.63,0,0,1,248.42,341.591Z",
    transform: "translate(-245.413 -324.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M203.092,380.246V379.6c.31.181.576.356.858.5a14.768,14.768,0,0,0,5.922,1.4,19.573,19.573,0,0,0,3.34-.094l.468.417,1.086.966.18.161c.182.164.37.333.576.5a2.139,2.139,0,0,0,.737.392,14.1,14.1,0,0,1-3.879.767,17.236,17.236,0,0,1-6.313-.627,6.132,6.132,0,0,1-2.314-1.2,1.733,1.733,0,0,1-.666-1.461C203.11,380.968,203.092,380.606,203.092,380.246Z",
    transform: "translate(-203.084 -362.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M180.517,400.2c0,.016-.009.033-.015.049V400.2Z",
    transform: "translate(-164.831 -380.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M181.06,298.218a1.948,1.948,0,0,0-1.134-1.577,9.613,9.613,0,0,0,1.227-.687c0,.593-.007,1.148,0,1.7A1.506,1.506,0,0,1,181.06,298.218Z",
    transform: "translate(-165.405 -288.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M216.152,299.409a1.912,1.912,0,0,1-.977-1.322c-.063-.646-.014-1.3-.014-1.977a.828.828,0,0,1,.1.048,9.874,9.874,0,0,0,3.4,1.4,19.488,19.488,0,0,0,6.658.349c.559-.065,1.111-.148,1.656-.259-.785.693-1.572,1.391-2.338,2.07l-.629.558-.306.272-.532.471a17.492,17.492,0,0,1-4.085-.419A8.21,8.21,0,0,1,216.152,299.409Z",
    transform: "translate(-215.142 -288.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M138.715,325.162l-1.474-1.311-2.394-2.129c-.2-.182-.2-.219.007-.406l.443-.392,1.094-.969.952-.844q1.3-1.15,2.6-2.3a.275.275,0,0,1,.167-.057.163.163,0,0,1,.051.007c.043.014.076.123.077.189.005.4,0,.793,0,1.189,0,.036,0,.071,0,.107,0,.267,0,.535,0,.813l.112.01a6.025,6.025,0,0,1,1.294.217q.227.064.449.145a6.341,6.341,0,0,1,1.147.557,7.5,7.5,0,0,1,3.019,3.7,13.028,13.028,0,0,1,.865,4.931c0,.091-.018.167-.123.181l-.028,0c-.1,0-.13-.085-.156-.168a6.384,6.384,0,0,0-2.324-3.223,7.309,7.309,0,0,0-2.4-1.232q-.26-.074-.529-.126a6.3,6.3,0,0,0-.631-.091c-.084-.008-.168-.01-.252-.01-.145,0-.292.007-.442.007,0,.076,0,.132,0,.188q0,.268,0,.536c0,.465,0,.93,0,1.394,0,.076-.039.2-.084.215a.149.149,0,0,1-.038,0,.35.35,0,0,1-.2-.077c-.242-.2-.472-.413-.707-.622Z",
    transform: "translate(-126.343 -306.642)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/withdraw.icon.60414248b2e57e8aa34685559982f895.svg";
export { ForwardRef as ReactComponent };